export const servicesData = [
  {
    id: 1,
    icon: 'ri-layout-grid-line',
    title: 'Web Design',
    description: 'Custom-built, conversion-optimized websites that turn visitors into customers. Mobile-responsive designs that showcase your expertise and build trust instantly.',
    features: [
      'Mobile-responsive design',
      'Conversion-optimized layouts',
      'Fast loading speeds',
      'SEO-friendly structure'
    ]
  },
  {
    id: 2,
    icon: 'ri-robot-2-line',
    title: 'AI Integration',
    description: 'Leverage cutting-edge AI technology to automate customer interactions, qualify leads 24/7, and provide instant responses that keep your pipeline full.',
    features: [
      '24/7 automated responses',
      'Lead qualification',
      'Appointment scheduling',
      'Customer support automation'
    ]
  },
  {
    id: 3,
    icon: 'ri-search-line',
    title: 'SEO',
    description: 'Dominate local search results and get found by customers actively searching for your services. Proven strategies that deliver consistent organic traffic and leads.',
    features: [
      'Local SEO optimization',
      'Keyword research & targeting',
      'Content optimization',
      'Monthly performance reports'
    ]
  },
  {
    id: 4,
    icon: 'ri-megaphone-line',
    title: 'Social Media Organic & Paid Ads',
    description: 'Strategic social media campaigns that build brand awareness and generate qualified leads. Expert management of both organic content and high-converting paid advertisements.',
    features: [
      'Content creation & posting',
      'Targeted ad campaigns',
      'Audience engagement',
      'Performance analytics'
    ]
  },
  {
    id: 5,
    icon: 'ri-google-line',
    title: 'Google LSA + PPC',
    description: 'Maximize your ROI with expertly managed Google Local Service Ads and Pay-Per-Click campaigns. Get your business in front of ready-to-buy customers at the perfect moment.',
    features: [
      'Google LSA setup & management',
      'PPC campaign optimization',
      'Bid management',
      'Conversion tracking'
    ]
  },
  {
    id: 6,
    icon: 'ri-star-smile-line',
    title: 'Reputation Management',
    description: 'Build and protect your online reputation with strategic review generation and management. Turn satisfied customers into powerful advocates for your business.',
    features: [
      'Review generation campaigns',
      'Review monitoring & responses',
      'Reputation repair strategies',
      'Rating improvement plans'
    ]
  }
];
